import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {OAuthService} from "angular-oauth2-oidc";
import {Observable} from "rxjs";
import {parametresClient} from "../../../val-definitions-communes-lib/src/public-api";
import {EnTeteContexteUtilisateur, JetonContexteService} from "./jeton-contexte.service";

//Ajoute les propriétés d’authorisation
export const AjouterAutorisation: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) : Observable<HttpEvent<any>> =>
{
  const isOidcRequest =
    req.url.includes('/.well-known/openid-configuration') ||
    req.url.includes('/protocol/openid-connect') ||
    req.url.includes('/realms/');

  if (isOidcRequest) {
    return next(req);
  }


  let requete: HttpRequest<any>;

  const oAuthService: OAuthService = inject (OAuthService);
  const token: string = oAuthService.getAccessToken ();
  const jetonContexteService: JetonContexteService = inject (JetonContexteService);

  if (token)
  {
    const enTetes: Record<string, string> =
    {
      Authorization: `Bearer ${token}`,
      IDENTIFIANT_CLIENT: parametresClient.identifiant,
      URL_API_CORE: parametresClient.urlApi
    };

    //Le jeton de contexte n’accompagne l’appel que s’il existe et qu’il tient dans l’en-tête.
    //Son absence n’est pas une anomalie : les APIs lisent alors le contexte directement dans
    //Ammon Permissions. Il voyage partout où va l’en-tête Authorization, et pas au-delà — il est
    //inexploitable sans le jeton Keycloak auquel il est apparié, donc strictement moins sensible.
    //JetonTransmissible et non Jeton : c’est le service qui borne la taille, cf. TailleMaxEnTete.
    //Angular continue de lire le jeton pour lui-même, un jeton non transmis reste donc en session.
    const jetonContexte: string | null = jetonContexteService.JetonTransmissible;

    if (jetonContexte)
      enTetes[EnTeteContexteUtilisateur] = jetonContexte;

    requete = req.clone ({setHeaders: enTetes});
  }
  else
    requete = req;

  return next (requete);
}